<template>
  <!-- 退换货标签打印 -->
  <div>
    <article class="return-label-page" v-for="(item, index) in printData" :key="index">
      <article class="return-label">
      <article class="return-label-head">
        <p class="return-label-purchase-no">{{ item.purchase_no }}</p>
        <p class="return-label-customer-product">
          {{ item.alibaba_full_name }}
        </p>
        <p class="return-label-summary">

          <span class="return-label-num">{{ item.refund_num_total }}</span>
          <span class="return-label-type">{{ item.type_name }}</span>
        </p>
      </article>

      <article class="return-label-content">
        <article class="return-label-info-item return-label-refund-info">
          <p class="return-label-info-name">退换货编号：</p>
          <p class="return-label-info-value">{{ item.refund_sn }}</p>
        </article>
        <article class="return-label-info-item return-label-express-info">
          <p class="return-label-info-name">物流号：</p>
          <p class="return-label-info-value">
            {{ item.order_purchase_refund_detail_express != false
              ? item.order_purchase_refund_detail_express[0].refund_express_no : '' }}
          </p>
        </article>
      </article>

      <article class="return-label-footer">
        <p class="return-label-customer-id">客户ID：<b>{{ item.user.id }}</b></p>
        <article class="return-label-staff">
          <p>采购员：<b>{{ item.g_admin.realname }}</b></p>
          <p>配货员：<b>{{ item.p_admin.realname }}</b></p>
        </article>
      </article>
      </article>
    </article>
  </div>
</template>

<script>
export default {
  props: {
    printData: { type: Array }
  },
  methods: {
    getOrderCode(orderSn) {
      return orderSn.split('-')[0].slice(-5)
    }
  },
}
</script>

<style scoped>
.return-label-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  min-width: 1181px;
  min-height: 1702px;
  box-sizing: border-box;
  page-break-after: always;
}

.return-label {
  position: relative;
  width: 1080px;
  height: 1600px;
  margin: 40px;
  border: 5px solid #000;
  box-sizing: border-box;
  color: #000 !important;
  font-family: "Microsoft YaHei", SimHei, Arial, sans-serif;
  overflow: hidden;
}

.return-label p {
  margin: 0;
  padding: 0;
}

.return-label-head {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 760px;
}

.return-label-purchase-no {
  position: absolute;
  left: 40px;
  right: 40px;
  top: 60px;
  font-size: 80px;
  font-weight: 600;
  line-height: 100px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-all;
}

.return-label-customer-product {
  position: absolute;
  left: 40px;
  top: 290px;
  font-size: 118px;
  font-weight: 700;
  line-height: 170px;
  white-space: nowrap;
}

.return-label-summary {
  position: absolute;
  left: 40px;
  top: 510px;
  font-size: 118px;
  line-height: 170px;
  white-space: nowrap;
}

.return-label-summary span {
  display: inline-block;
  vertical-align: baseline;
}

.return-label-order-index {
  margin-right: 48px;
  font-weight: 400;
}

.return-label-num {
  margin-right: 60px;
  font-weight: 700;
}

.return-label-type {
  font-weight: 700;
}

.return-label-content {
  position: absolute;
  left: 0;
  top: 760px;
  width: 100%;
  height: 595px;
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
  box-sizing: border-box;
}

.return-label-info-item {
  position: absolute;
  left: 40px;
  right: 40px;
  height: 200px;
}

.return-label-refund-info {
  top: 48px;
}

.return-label-express-info {
  top: 321px;
}

.return-label-info-name {
  font-size: 64px;
  line-height: 78px;
}

.return-label-info-value {
  position: absolute;
  left: 0;
  top: 105px;
  font-size: 70px;
  font-weight: 600;
  line-height: 100px;
  white-space: nowrap;
}

.return-label-footer {
  position: absolute;
  left: 0;
  top: 1355px;
  width: 100%;
  height: 240px;
  font-size: 44px;
  line-height: 58px;
}

.return-label-customer-id {
  position: absolute;
  left: 40px;
  top: 80px;
  white-space: nowrap;
}

.return-label-staff {
  position: absolute;
  right: 32px;
  top: 48px;
  line-height: 75px;
  white-space: nowrap;
}
</style>